import { render, staticRenderFns } from "./AttendanceIndicator.vue?vue&type=template&id=ec15cfea"
import script from "./AttendanceIndicator.vue?vue&type=script&lang=js"
export * from "./AttendanceIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports